var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"talk-item"},[_c(_vm.getComponentToRender(_vm.source),{tag:"component",attrs:{"item":_vm.source},on:{"createBranch":_vm.createBranch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }